<template>
    <div v-if="product.productServiceGroups.length > 0">
        <b-input-group
            id="services"
            v-for="(service, sindex) in product.productServiceGroups[0].availableProductServices"
            v-bind:key="service.productService"
        >
            <input
                type="checkbox"
                class="form-check-input"
                v-model="service.selected"
                :name="'SelectedProductService_' + index + '_' + sindex"
                @change="selectService(service)"
            />
            {{ $t('createShipment.services.' + service.productService) }}
        </b-input-group>
    </div>
</template>
<script>
  import { EventBus } from '@/services/event-bus.js';
  import {
      ACTIONS,
      MUTATIONS,
      CREATE_SHIPMENT_PREFIX,
      CORE_PREFIX,
      GETTERS,
  } from '../store/constants';
  import { mapState, mapGetters } from 'vuex';
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import viewOptions from '../mixins/viewOptionsMixin';
  import { FIELD_NAMES, EVENTS } from '../store/nameConstants';
  import helper from '../helper';
  import store from '../store';
  import Vue from 'vue';
  export default {
      props: {
          getShipmentPrice: { type: Function, required: true },
          index: { required: true },
          product: { type: Object, required: true },
          selectedServices: { type: Array, required: true },
      },
      components: {},
      data() {
          return {
              fieldNames: FIELD_NAMES,
              basePrice: {},
              originalPriceLines: [],
          };
      },
      created() {
          this.basePrice = helper.cloneObject(this.product.priceLines);
          this.originalPriceLines = helper.cloneObject(this.product.priceLines);
      },
      destroyed() {
          this.product.selectedService = null;
          this.product.priceLines = this.basePrice;

          this.product.productServiceGroups[0].availableProductServices.forEach((ps) => {
              ps.selected = false;
          });
      },
      mixins: [viewOptions],
      methods: {
          getTotalPrice(priceLines) {
              let totalPrice = 0;

              priceLines.forEach((element) => (totalPrice += element.value));

              return totalPrice.toFixed(2);
          },

          selectService(service) {
            this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);

            this.product.priceLines = helper.cloneObject(this.originalPriceLines)


              //Allow serviceId 12 to be combined with other serviceids
              this.product.productServiceGroups[0].availableProductServices.forEach((ps) => {
                  if (ps.serviceId === service.serviceId) {
                      return;
                  }
                  // Allow serviceId 12 to be combined: don't deselect it, and don't deselect others if 12 is the one being toggled
                  if (ps.serviceId === 12 || service.serviceId === 12) {
                    return;
                  }
                if (ps.serviceId === 13 || service.serviceId === 13) {
                  return;
                }
                const index = this.selectedServices.findIndex(item => item.serviceId === ps.serviceId);
                if (index !== -1){
                  this.selectedServices.splice(index, 1);
                }
                  ps.selected = false;
              });

              if (service.selected === false) {
                const index = this.selectedServices.findIndex(item => item.serviceId === service.serviceId);
                if (index !== -1){
                  this.selectedServices.splice(index, 1);
                }
                  this.product.priceLines = helper.cloneObject(this.originalPriceLines)
              } else {
                  const index = this.selectedServices.findIndex(item => item.serviceId === service.serviceId);
                  if (index === -1) {
                    this.selectedServices.push(service);
                  }
                this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);

                if (!service.productServiceName || service.productServiceName === ""){
                    let result  = this.getShipmentPrice(this.product);
                    result.then((priceLines) => {
                        this.product.priceLines = priceLines;
                        this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);

                    })
                }
              }

              this.updateAdditionalServicesPrice();
              this.product.selected = true;
              this.$emit('setSelectedProduct', this.product);
              this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
          },
          updateAdditionalServicesPrice(){
              for (let index = 0; index < this.selectedServices.length; index++) {
                let service = this.selectedServices[index];
                this.product.priceLines.push({
                  chargeTypeId: 0,
                  text: service.productServiceName,
                  value: service.price
                })

                this.product.priceLines.forEach((p) => {
                  if (p.text === "Fuel") {
                    p.value += service.fuel
                  }
                })
              }
          }
      },
      computed: {
          ...mapGetters('createShipment', [
              'getShippingOptions',
              'getBackendErrors',
              'getServicePrices',
          ]),
      },
  };
</script>
